<div appFocusNearest class="favoriten-container" *isLoading="isLoading$ | async">
  <p class="favoriten-info" [markdown]="'components.favoriten.infoText' | translate" [markdownInline]="true"></p>

  <ng-container *ngIf="favoriteGroups$ | async as favoriteGroups">
    <p class="uba-card-list__empty" *ngIf="favoriteGroups.length === 0">{{ 'components.favoriten.emptyMessage' | translate }}</p>

    <bs-tabs *ngIf="favoriteGroups.length > 0">
      <bs-tab *ngFor="let group of favoriteGroups; let i = index"
              [label]="('components.favoriten.tabs.' + group.objektTyp | translate) + ' (' + group.favorites.length + ')'"
              [active]="i === 0">
        <ul class="uba-card-list">
          <li *ngFor="let favorite of group.favorites" class="uba-card-list__item">
            <a [routerLink]="objektUrl(favorite)" class="uba-card-list__link" title="{{ favorite.displayName }}">
              <span class="uba-card-list__name">{{ favorite.displayName }}</span>
              <span class="uba-card-list__meta">{{ favorite.objektId }}</span>
            </a>
            <div class="uba-card-list__actions">
              <button 
                (click)="removeFavorite(favorite.objektTyp, favorite.objektId, $event)" 
                class="uba-card-list__action uba-card-list__action--danger"
                [title]="'components.favoriten.removeTitle' | translate"
                [attr.aria-label]="'components.favoriten.removeLabel' | translate">
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </li>
        </ul>
      </bs-tab>
    </bs-tabs>
  </ng-container>
</div>
